import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
  useEffect,
} from "react";

interface FiltersContextType {
  filters: FiltersSend | null;
  setFilters: (newFilters: FiltersSend) => void;
  filtersConfig: Filters[] | null;
  setFiltersConfig: (config: Filters[]) => void;
  isFiltersLoading: boolean;
  setIsFiltersLoading: (loading: boolean) => void;
  handleApiFilter: ((filters: FiltersSend) => void) | null;
  setHandleApiFilter: (fn: ((filters: FiltersSend) => void) | null) => void;
}

const FilterContext = createContext<FiltersContextType | undefined>(undefined);

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilters deve ser usado dentro do FiltersProvider");
  }
  return context;
};

export const FiltersProvider = ({
  children,
  initialValues,
  initialConfig,
}: {
  children: ReactNode;
  initialValues?: FiltersSend;
  initialConfig?: Filters[];
}) => {
  const [filters, setFiltersState] = useState<FiltersSend>(
    initialValues as FiltersSend,
  );
  const [filtersConfig, setFiltersConfigState] = useState<Filters[] | null>(
    initialConfig || null,
  );
  const [isFiltersLoading, setIsFiltersLoading] = useState(false);
  const [handleApiFilter, setHandleApiFilter] = useState<
    ((filters: FiltersSend) => void) | null
  >(null);

  const setFilters = useCallback((newFilters: FiltersSend) => {
    setFiltersState(newFilters);
  }, []);

  const setFiltersConfig = useCallback((config: Filters[]) => {
    setFiltersConfigState(config);
  }, []);

  useEffect(() => {
    if (initialConfig) {
      setFiltersConfigState(initialConfig);
    }
  }, [initialConfig]);
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      setFiltersState(initialValues);
    }
  }, [initialValues]);

  return (
    <FilterContext.Provider
      value={{
        filters,
        setFilters,
        filtersConfig,
        setFiltersConfig,
        isFiltersLoading,
        setIsFiltersLoading,
        handleApiFilter,
        setHandleApiFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
